import { combineReducers } from 'redux'
import client, { defaultState as clientState } from './client'
import disableEpics, { defaultState as disableEpicsState } from './disableEpics'
import featureFlags, { defaultState as featureFlagsState } from './featureFlags'
import flashMessage, { defaultState as flashMessageState } from './flashMessage'
import form, { defaultState as formState } from './form'
import isBotTraffic, { defaultState as botTrafficState } from './botTraffic'
import locale, { defaultState as localeState } from './locale'
import location, { defaultState as locationState } from './location'
import isMobileTraffic, { defaultState as mobileTrafficState } from './mobileTraffic'
import modal, { defaultState as modalState } from './modal'
import qa, { defaultState as QAState } from './qa'
import navigation, { defaultState as navigationState } from './navigation'

export const defaultState = {
  client: clientState,
  disableEpics: disableEpicsState,
  featureFlags: featureFlagsState,
  flashMessage: flashMessageState,
  form: formState,
  isBotTraffic: botTrafficState,
  isMobileTraffic: mobileTrafficState,
  locale: localeState,
  location: locationState,
  modal: modalState,
  navigation: navigationState,
  qa: QAState,
}

export { client, featureFlags, isBotTraffic, isMobileTraffic, navigation }

export default combineReducers({
  client,
  disableEpics,
  featureFlags,
  flashMessage,
  form,
  isBotTraffic,
  isMobileTraffic,
  locale,
  location,
  modal,
  navigation,
  qa,
})
